import {
  GET_USERS,
  DELETE_USER,
  UPDATE_USER,
  CREATE_USER,
  USER_SUCCESS,
  USER_ERROR,
  USERS,
} from '../actions';

const INIT_STATE = {
  users: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS:
    case DELETE_USER:
    case UPDATE_USER:
    case CREATE_USER:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case USERS:
      return {
        ...state,
        users: action.payload,
      };
    case USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return { ...state };
  }
};
